import {getAppTracer} from '../../../app.tracer';
import {IBrowserNotSupportedStore, BrowserNotSupportedStore} from './browser-not-supported.stores';
import {getRootStore} from '../../app.bootstrap';

const trace = getAppTracer('browser-not-supported.loader');

export async function browserNotSupportedRouteLoader(): Promise<IBrowserNotSupportedStore> {
    trace.info('Starting');

    const {browserNotSupportedState} = getRootStore().appState;

    const store = new BrowserNotSupportedStore(browserNotSupportedState.browserInfo, browserNotSupportedState.userName);

    trace.info('Completed successfully');
    return store;
}
